import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.scss';

const CardFooter = ({ children }) => <div className={styles.cardFooter}>{children}</div>;

CardFooter.propTypes = {
    children: PropTypes.node.isRequired,
};

export default CardFooter;
